"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * New Api\'s for all actions
 * Actions APIs
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: ggrigorian@tivo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpcomingEmptyListType = void 0;
/**
 * Upcoming Empty list type.
 * @export
 * @enum {string}
 */
exports.UpcomingEmptyListType = {
    EmptyListUpcomingRecord: 'emptyListUpcomingRecord',
    EmptyListUpcoming: 'emptyListUpcoming'
};
